module.exports = {
  WORKSPACE_ROLES_CAPABILITIES: {
    roleHierarchyBasedOnIndex: ["BRONZE", "SILVER", "GOLD", "OWNER"], //"GUEST" remove for now but need to add later
    manageWorkspace: ["OWNER", "GOLD"],
    deleteWorkspace: ["OWNER"],
    manageMembers: ["OWNER", "GOLD"],
    editInvitationLink: ["OWNER"],
    viewNotifications: ["OWNER", "GOLD", "SILVER"],
    properties: {
      add: ["OWNER", "GOLD", "SILVER"],
      edit: ["OWNER", "GOLD", "SILVER"],
      delete: ["OWNER", "GOLD", "SILVER"],
      share: ["OWNER", "GOLD", "SILVER"],
      linkTenant: ["OWNER", "GOLD", "SILVER"],
      award: ["OWNER", "GOLD", "SILVER"],
      purchaseInsurance: ["OWNER", "GOLD", "SILVER"],
    },
    tenants: {
      generateReport: ["OWNER", "GOLD", "SILVER", "BRONZE"],
      inviteTenant: ["OWNER", "GOLD", "SILVER"],
      viewGuarantors: ["OWNER", "GOLD", "SILVER", "BRONZE"],
      share: ["OWNER", "GOLD", "SILVER"],
      interactionRoles: ["OWNER", "GOLD", "SILVER"],
    },
    tenantChecks: {
      add: ["OWNER", "GOLD", "SILVER"],
      edit: ["OWNER", "GOLD", "SILVER"],
    },
    selfServing: ["OWNER", "GOLD", "SILVER"],
    nonGuestRoles: ["OWNER", "GOLD", "SILVER", "BRONZE"],
    tenantManagement: ["OWNER", "GOLD", "SILVER", "BRONZE"],
    propertyManagement: ["OWNER", "GOLD", "SILVER", "BRONZE"],
  },
};
